module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowBlack.6234cb4.woff2";